import React from 'react';
import './SoftwareDetails.less';
import {SVGIcon} from '@homeaway/react-svg';
import {CLOSE__16} from '@homeaway/svg-defs/lib/defs/CLOSE__16';

export default class SoftwareHelpPanel extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let {translations, onClose} = this.props;

        return (<div className="side-panel-container">
            <div className="side-panel-close-btn-holder">
                <button className="side-panel-close-btn" onClick={onClose}>
                    <SVGIcon markup={CLOSE__16} />
                </button>
            </div>
            <div className="content-holder">
                <div className="content-holder side-panel-content">
                    <div className="wrapper">
                        <div className="side-panel-heading">
                            <h2>{translations['ipmob.software_details.id.help.heading']}</h2>
                        </div>
                    </div>
                    <div className="wrapper" >
                        <div className="content-holder" >
                            <div className="side-panel-id-info-holder" >
                                <div className="side-panel-id-info-holder-int" >
                                    <p>{translations['ipmob.software_details.id.help.highlight_text']}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="wrapper" >
                        <div className="content-holder" >
                            <div className="side-panel-desc" >
                                <div className="side-panel-desc-text" >
                                    <p>{translations['ipmob.software_details.id.help.text']}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }
}
